import React, { useState } from "react";

import { ColunaKanban } from "./ColunaKanban";


const etapas = [

  {
    status:"NOVO",
    titulo:"Novos Leads"
  },

  {
    status:"CONTATO",
    titulo:"Contato"
  },

  {
    status:"QUALIFICADO",
    titulo:"Qualificados"
  },

  {
    status:"PROPOSTA",
    titulo:"Proposta"
  },

  {
    status:"NEGOCIACAO",
    titulo:"Negociação"
  },

  {
    status:"GANHO",
    titulo:"Clientes"
  }

];



export function KanbanCRM({ contatos = [], onStatusChange }) {


  const [listaContatos, setListaContatos] = useState(contatos);



  async function moverContato(id, novoStatus){


    const atualizados = listaContatos.map((contato)=>{

      if(contato.id == id){

        return {
          ...contato,
          status: novoStatus
        };

      }

      return contato;

    });


    setListaContatos(atualizados);



    // chama API para salvar no banco

    if(onStatusChange){

      onStatusChange(
        id,
        novoStatus
      );

    }


  }



  return (

    <div
      className="
        grid
        grid-cols-1
        md:grid-cols-2
        xl:grid-cols-6
        gap-4
        overflow-x-auto
      "
    >


      {
        etapas.map((etapa)=>(


          <ColunaKanban

            key={etapa.status}

            titulo={etapa.titulo}

            status={etapa.status}


            contatos={
              listaContatos.filter(
                item => item.status === etapa.status
              )
            }


            onDropContato={moverContato}


          />


        ))
      }


    </div>

  );

}